import React, { useCallback, useEffect, useState } from 'react';
import {
  Heading,
  HStack,
  VStack,
  Text,
  Divider,
  Switch,
  Flex,
} from 'native-base';
import { useAuth } from '../../hooks';
import { Loader } from '../Loader';

export const Notifications = () => {
  const { loading, updateUserSelf, user } = useAuth();

  const initialFormData = {
    optInMarketing: user?.opt_in_marketing,
    optInNews: user?.opt_in_news,
  };
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (user?.email && !formData) {
      setFormData(initialFormData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const save = useCallback(
    async (setting) => {
      await updateUserSelf({
        ...user,
        ...setting,
      });
    },
    [updateUserSelf, user]
  );

  if (loading) return <Loader loading={loading} />;

  return (
    <VStack alignItems={'start'} w={'100%'} mt={4}>
      <Heading color="black" size="md" textAlign="left">
        Notifications
      </Heading>
      <VStack alignItems={'start'} w={'60%'}>
        <HStack w={'100%'} alignItems={'center'}>
          <Flex my={8} flex={1} flexDirection={'column'} w={'100%'}>
            <Heading
              textAlign={'left'}
              size={'sm'}
              fontFamily={'body'}
              fontWeight={'bold'}
            >
              News and Update Emails
            </Heading>
            <Text flexShrink={'1'} mt={1}>
              We’ll email you updates about programs and features.
            </Text>
          </Flex>
          <Switch
            isChecked={formData?.optInNews}
            my={2}
            onToggle={() => {
              save({ optInNews: !formData?.optInNews });
            }}
          />
        </HStack>
        <Divider my={2} />
        <HStack w={'100%'} alignItems={'center'}>
          <Flex my={8} flex={1} flexDirection={'column'} w={'100%'}>
            <Heading
              textAlign={'left'}
              size={'sm'}
              fontFamily={'body'}
              fontWeight={'bold'}
            >
              Marketing Emails
            </Heading>
            <Text flexShrink={'1'} mt={1}>
              Science-backed gastro tips, recipes, gut health lifestyle advice
              and more right to your inbox from our dietitians.
            </Text>
          </Flex>
          <Switch
            isChecked={formData?.optInMarketing}
            ml={2}
            onToggle={() => {
              save({ optInMarketing: !formData?.optInMarketing });
            }}
          />
        </HStack>
        <Divider my={2} />
      </VStack>
    </VStack>
  );
};
